export default "__VITE_ASSET__BC8B9Wmi__"